import React, { useState, useEffect } from 'react';

interface IProps {
  src: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  rotated?: boolean;
  iconId?: string;
  iconKey?: string;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  isSelected?: boolean;
}

const Icon = ({
  src, className, rotated, onClick, iconId, iconKey, handleMouseLeave, handleMouseEnter, isSelected,
}: IProps) => {
  const [isRotate, setIsRotate] = useState<boolean>(rotated || false);

  useEffect(() => {
    if (rotated) {
      setIsRotate(true);
    } else {
      setIsRotate(false);
    }
  }, [rotated]);

  return <img onMouseEnter={handleMouseEnter ?? (() => {})} onMouseLeave={handleMouseLeave ?? (() => {})} key={iconKey} data-testid='icon' data-isselected={isSelected ? 'true' : null} id={`icon${iconId ?? ''}`} role='presentation' src={src} alt={iconId || ''} className={`${className} ${isRotate ? 'rotate-180' : 'rotate-0'}`} onClick={onClick} />;
};

export default Icon;
